import { getEntityMarker } from "./getEntityMarker.js";
import { assertNever } from "../../utils/assertNever.js";
class StateIterator {
  static *eachSiblingRealm(state, relevantPlaceholder) {
    for (let [realmKey, realm] of state.entity.realms) {
      if (realm.type === "entityRealmStub") {
        if (relevantPlaceholder === void 0 || getEntityMarker(realm).fields.placeholders.has(relevantPlaceholder)) {
          realm.getAccessor();
          realm = state.entity.realms.get(realmKey);
        } else {
          continue;
        }
      }
      yield realm;
    }
  }
  // Note that this only yields siblings with the same placeholderName!
  static *eachSiblingRealmChild(treeStore, state) {
    if (state.type === "entityList" && state.blueprint.parent === void 0) {
      for (const [, rootStates] of treeStore.subTreeStatesByRoot) {
        const rootList = rootStates.get(state.blueprint.marker.placeholderName);
        if (rootList?.type === "entityList") {
          yield rootList;
        }
      }
      return;
    }
    let closestEntityRealm;
    let placeholderName;
    if (state.type === "field") {
      closestEntityRealm = state.parent;
      placeholderName = state.placeholderName;
    } else if (state.type === "entityList") {
      closestEntityRealm = state.blueprint.parent;
      placeholderName = state.blueprint.marker.placeholderName;
    } else {
      return assertNever();
    }
    for (const realm of this.eachSiblingRealm(closestEntityRealm, placeholderName)) {
      const child = realm.children.get(placeholderName);
      if (child === void 0) {
        continue;
      }
      if (child.type === state.type) {
        yield child;
      }
    }
  }
  static *depthFirstAllNodes(root) {
    switch (root.type) {
      case "entityRealm":
      case "entityList":
        for (const childState of root.children.values()) {
          switch (childState.type) {
            case "field":
            case "entityRealm":
            case "entityList":
              yield* this.depthFirstAllNodes(childState);
              break;
            case "entityRealmStub":
              break;
            default:
              return assertNever();
          }
        }
        break;
      case "field":
        break;
      default:
        return assertNever();
    }
    yield root;
  }
  static *depthFirstINodes(root, match) {
    switch (root.type) {
      case "entityRealm":
      case "entityList":
        for (const childState of root.children.values()) {
          if (childState.type === "entityRealm" || childState.type === "entityList") {
            yield* this.depthFirstINodes(childState, match);
          }
        }
        break;
      default:
        return assertNever();
    }
    if (match === void 0 || match(root)) {
      yield root;
    }
  }
  static *eachRootState(treeStore) {
    for (const rootStates of treeStore.subTreeStatesByRoot.values()) {
      yield* rootStates.entries();
    }
  }
}
export {
  StateIterator
};
//# sourceMappingURL=StateIterator.js.map
